import VerifyOtp from "../../../../component/verify_otp";
import EnterEmailMobile from "../../../../component/enter_email_mobile";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

import {
  actionLogin,
  actionLoginSendOtp,
  actionLoginVerifyOtp,
  resetLoginOtpResponse,
  resetVerifyLoginOtpResponse,
  actionRegistrationForm,
  resetRegistrationFormResponse,
  actionVerifyRegOtp,
  resetVerifyRegOtpResponse,
} from "../store";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../common/app_constant";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Registration from "../../../../component/registration_form";
import VerifyRegOtp from "../../../../component/verify_reg_otp";
import LandingSection from "../landing_section";
import { SUB_DIRECTORY } from "../../../../common/constant";
import { getNextScreen } from "../../../../utils";
const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // OTP- response
  const { getLoginOtp } = useSelector(state => ({
    ...state.publicStore,
  }));

  // Login VerifyLoginOTP
  const { getVerifyLoginOtp, getVerifyLoginOtpError, xyz } = useSelector(state => ({
    ...state.publicStore,
  }));

  // Registration Form
  const { registrationForm, getVerifyRegOtp } = useSelector(state => ({
    ...state.publicStore,
  }));




  const [screenMode, setscreenMode] = useState("sendotp");
  const [loginData, setLoginData] = useState({ code: "axis" });
  const [getRegistration, setRegistration] = useState(false);
  const [regData, setRegData] = useState()
  const [verifiedUser, setVerifiedUser] = useState(false)
  const [otpAttempts, setOtpAttempts] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const bannerHeading = {
    // backgroundColor: "rgba(237,17,100,0.2)",

    fontSize: "34px",
    fontWeight: "900",
    lineHeight: "38.43px",
    // letterSpacing: "-0.01em",
  };
  const copyrightText = {
    // backgroundColor: "rgba(237,17,100,0.2)",
    fontSize: "14px",
    fontWeight: "bold",
  }

  // api call on update ---- > when response is true
  // setGetOTP(true)

  // useEffect(() => {
  //   if (getLoginOtp !== null) {
  //     dispatch(resetLoginOtpResponse());
  //     console.log("TESTE", getLoginOtp?.data)
  //     if (getLoginOtp?.status === true) {
  //       setscreenMode("verifyotp");
  //       toast.success(getLoginOtp?.message, {
  //         duration: TOAST_DURATION,
  //         position: TOAST_POSITION,
  //         style: {
  //           color: TOAST_SUCCESS_COLOR,
  //         }
  //       });
  //     } else {
  //       toast.error(getLoginOtp?.message, {
  //         duration: TOAST_DURATION,
  //         position: TOAST_POSITION,
  //         style: {
  //           color: TOAST_SUCCESS_COLOR,
  //         },
  //       });
  //     }
  //   }
  // }, [getLoginOtp]);

  useEffect(() => {
  if (getLoginOtp !== null) {
    dispatch(resetLoginOtpResponse());
    console.log("TESTE", getLoginOtp?.data);

    if (getLoginOtp?.status === true) {
      setscreenMode("verifyotp");
      toast.success(getLoginOtp?.message, {
        duration: TOAST_DURATION,
        position: TOAST_POSITION,
        style: {
          color: TOAST_SUCCESS_COLOR,
        },
      });
      // Reset attempts on successful OTP
      setOtpAttempts(0);
      setIsDisabled(false);
    } else {
      // Increment attempts on failure
      setOtpAttempts((prev) => {
        const newCount = prev + 1;
        if (newCount >= 3) {
          setIsDisabled(true); // Disable button after 3 failed attempts
          toast.error("You have reached maximum OTP attempts.", {
            duration: TOAST_DURATION,
            position: TOAST_POSITION,
            style: {
              color: TOAST_ERROR_COLOR,
            },
          });
        }
        return newCount;
      });

      toast.error(getLoginOtp?.message, {
        duration: TOAST_DURATION,
        position: TOAST_POSITION,
        style: {
          color: TOAST_ERROR_COLOR,
        },
      });
    }
  }
}, [getLoginOtp]);

  useEffect(() => {
    if (getVerifyLoginOtp !== null) {
      dispatch(resetVerifyLoginOtpResponse());
      if (getVerifyLoginOtp?.status) {
        const decoded = jwtDecode(getVerifyLoginOtp?.data?.token);
        getNextScreen(decoded?.role)
        localStorage.setItem("userData", JSON.stringify(getVerifyLoginOtp.data.userData));
        localStorage.setItem("token", JSON.stringify(getVerifyLoginOtp.data.token));
        navigate("/policies");
        window.location.reload();
      } else {
        toast.error(getVerifyLoginOtp.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [getVerifyLoginOtp]);

  useEffect(() => {
    if (registrationForm !== null) {
      dispatch(resetRegistrationFormResponse());
      if (registrationForm?.status === true) {
        // alert("IF");
      } else {
        toast.error(registrationForm?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  });


  // OLD code
  // useEffect(() => {
  //  if (getVerifyRegOtp !== null) {
  //   dispatch(resetVerifyRegOtpResponse());
  //   if (getVerifyRegOtp?.status && getVerifyRegOtp?.data?.is_verified) {
  //     // alert(getVerifyRegOtp?.data?.is_verified)
  //     localStorage.setItem("token", JSON.stringify(getVerifyRegOtp.data));
  //     localStorage.setItem("next", JSON.stringify(getVerifyLoginOtp.data.next));
  //       navigate("/policies");
  //       window.location.reload();
  //         // alert("hello",getVerifyLoginOtp?.data?.is_verified )
  //   }else{
  //     toast.error(getVerifyRegOtp?.message, {
  //       duration: TOAST_DURATION,
  //       position: TOAST_POSITION,
  //       style: {},
  //     });
  //   }
  //  }
  // },[getVerifyRegOtp])

  return (
    <div className="">
      <section>
        <div className="full-banner pt-5">
          <div className="container-xxl container-fluid">
            <div className="row justify-content-end">
              <div className="col-12 col-md-10 pt-4 pb-3 text-center mt-5">
                <span style={bannerHeading}>Experience an enhanced motor fleet policy <br />for your peace of mind</span>
              </div>
            </div>
            <div className="row d-flex justify-content-center mt-3">
              <div className="col-md-4 my-auto order-md-2 h-100 px-0 px-md-4 ">
                <div className="px-3 card">
                  <div className="card-body py-4">
                    {screenMode === "sendotp" && getRegistration === false ?
                      <EnterEmailMobile
                        handleClose={data => {
                          setLoginData(data);
                          dispatch(actionLoginSendOtp(data));
                        }}
                        handleRegistration={() => navigate("/registration")}
                        isDisabled={isDisabled} 

                      />
                      :
                      <></>
                    }
                    {screenMode === "verifyotp" && (
                      <VerifyOtp
                        handleClose={data => {
                          dispatch(
                            actionLoginVerifyOtp({ 'otp': data, ...loginData })
                          );
                        }}
                        resendOtp={data => {
                          dispatch(actionLoginSendOtp({ data, ...loginData }));
                        }}
                        loginData={{ ...loginData }}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div class="col-md-6 my-auto order-md-1 d-none d-md-inline text-end pe-5">
                <LandingSection />
              </div>
            </div>
            <div className="row justify-content-end">
              <div className="col-12 col-md-10 pt-4  text-center" >
                <span style={copyrightText}>
                  © All Rights Reserved. Copyright {new Date().getFullYear()} Pioneer Insurance & Reinsurance Broker Pvt. Ltd.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
